import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchAllLeadSourcesActive } from "../../api/leadsource";
import { fetchAllLeadStagesActive } from "../../api/leadstage";
import { fetchAllLeadTypesActive } from "../../api/leadtype";
import { fetchAllLeadIndustriesActive } from "../../api/leadindustry";
import { fetchAllProductsActive } from "../../api/product";
import { fetchAllProductTypesActive } from "../../api/producttype";
import { fetchAllCustomerPotentialsActive } from "../../api/customertype";
import { exportLeads } from "../../api/leadreport";
import { toast } from "react-toastify";

interface OptionType {
  label: string;
  value: string;
  isDisabled?: boolean;
}
const validateCity = (value: string): string | null => {
  const trimmed = value.trim();

  if (!trimmed) return null; // optional field

  if (trimmed.length > 50) {
    return "City name cannot exceed 50 characters.";
  }

  if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(trimmed)) {
    return "City name should contain only letters and single spaces.";
  }

  return null;
};

const ReportsModal = () => {
  const fieldOptions: OptionType[] = [
    { value: "ALL", label: "All Fields" },
    { value: "company_name", label: "Company Name" },
    { value: "contact_person_name", label: "Contact Person" },
    { value: "contact_person_designation", label: "Designation" },
    { value: "company_phone", label: "Phone" },
    { value: "company_mail", label: "Company Mail" },
    { value: "website_url", label: "Website" },
    { value: "company_remark", label: "Remarks" },
    { value: "lead_status", label: "Lead Status" },
    { value: "currency", label: "Currency" },
    { value: "no_logins", label: "Login Count" },
    { value: "rate_per_login", label: "Rate/Login" },
    { value: "total_amount", label: "Total Amount" },
    { value: "lead_owner_name", label: "Lead Owner" },
    { value: "lead_source_name", label: "Lead Source" },
    { value: "lead_industry_name", label: "Lead Business Type" },
    { value: "lead_stage_name", label: "Lead Stage" },
    { value: "lead_type_name", label: "Lead Type" },
    { value: "Product_Name", label: "Product Name" },
    { value: "product_type_name", label: "Product Type" },
    { value: "customer_type_name", label: "Customer Type" },
    { value: "client_name", label: "Client Name" },
    { value: "branch_name", label: "Branch Name" },
    { value: "branch_address", label: "Address" },
    { value: "branch_city", label: "City" },
    { value: "branch_state", label: "State" },
    { value: "branch_country", label: "Country" },
    { value: "gst_number", label: "GST" },
  ];

  const filterTypeOptions: OptionType[] = [
    { value: "", label: "Choose Filter Type", isDisabled: true },
    { value: "leadsource", label: "Lead Source" },
    { value: "leadstage", label: "Lead Stage" },
    { value: "leadtype", label: "Lead Type" },
    { value: "leadindustry", label: "Lead Business Type" },
    { value: "product", label: "Product" },
    { value: "producttype", label: "Product Type" },
    { value: "customertype", label: "Customer Type" },
  ];
  const monthOptions: OptionType[] = [
    { value: "", label: "Choose Month", isDisabled: true },
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const leadStatusOptions: OptionType[] = [
    { value: "", label: "Choose Status", isDisabled: true },
    { value: "Not_Contacted", label: "Not Contacted" },
    { value: "Contacted", label: "Contacted" },
    { value: "Closed", label: "Closed" },
    { value: "Lost", label: "Lost" },
  ];

  const [field, setField] = useState<OptionType[]>([]);
  const [exportType, setExportType] = useState<OptionType | null>(null);
  const [filterType, setFilterType] = useState<OptionType | null>(null);
  const [filterId, setFilterId] = useState<OptionType | null>(null);
  const [filterIdOptions, setFilterIdOptions] = useState<OptionType[]>([]);
  const [year, setYear] = useState<string>("");
  const [month, setMonth] = useState<OptionType | null>(null);
  const [branchCity, setBranchCity] = useState<string>("");
  const [leadStatus, setLeadStatus] = useState<OptionType | null>(null);
  const exportTypeOptions: OptionType[] = [
    { value: "", label: "Choose Export Type", isDisabled: true },
    { value: "pdf", label: "Download as PDF", isDisabled: field.length > 10 },
    { value: "excel", label: "Download as Excel" },
  ];
  useEffect(() => {
    const loadFilterOptions = async () => {
      if (!filterType) return;
      let data: any[] = [];
      switch (filterType.value) {
        case "leadsource":
          data = await fetchAllLeadSourcesActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.LeadSource_name,
              value: i.LeadSource_id || "",
            }))
          );
          break;
        case "leadstage":
          data = await fetchAllLeadStagesActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.LeadStage_name,
              value: i.LeadStage_id || "",
            }))
          );
          break;
        case "leadtype":
          data = await fetchAllLeadTypesActive();
          setFilterIdOptions(
            data.map((i) => ({ label: i.leadtype_name, value: i.leadtype_id }))
          );
          break;
        case "leadindustry":
          data = await fetchAllLeadIndustriesActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.LeadIndustry_name,
              value: i.LeadIndustry_id || "",
            }))
          );
          break;
        case "product":
          data = await fetchAllProductsActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.product_name,
              value: i.product_id || "",
            }))
          );
          break;
        case "producttype":
          data = await fetchAllProductTypesActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.product_name,
              value: i.product_type_id || "",
            }))
          );
          break;
        case "customertype":
          data = await fetchAllCustomerPotentialsActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.customerPotential_name,
              value: i.customerPotential_id || "",
            }))
          );
          break;
        default:
          setFilterIdOptions([]);
      }
    };
    loadFilterOptions();
  }, [filterType]);
  const resetForm = () => {
    setField([]);
    setExportType(null);
    setFilterType(null);
    setFilterId(null);
    setFilterIdOptions([]);
    setYear("");
    setMonth(null);
    setBranchCity("");
    setLeadStatus(null);
  };

  const handleDownload = () => {
    if (!field || !exportType || !year) {
      toast.warning(
        "Please fill all required fields: Field, Export Type and Year."
      );
      return;
    }
    const isPdfTooWide = exportType?.value === "pdf" && field.length > 10;

    if (isPdfTooWide) {
      toast.warning(
        "PDF export supports up to 10 fields. Please reduce the selection or use Excel."
      );
      return;
    }
    const cityError = validateCity(branchCity);
if (cityError) {
  toast.warning(cityError);
  return;
}

    exportLeads({
      fields: field.find((f) => f.value === "ALL")
        ? fieldOptions
            .filter((f) => f.value !== "ALL")
            .map((f) => f.value)
            .join(",")
        : field.map((f) => f.value).join(","),

      export_type: exportType.value as "pdf" | "excel",
      filter_type: filterType?.value || "",
      filter_id: filterId?.value ?? "",
      year: +year,
      month: month?.value ? +month.value : undefined,
      branch_city: branchCity,
      lead_status: leadStatus?.value,
    });
    resetForm();
  };
  
  return (
    <>
      <div
        className="modal custom-modal fade effect-modal-show"
        id="download_report"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header border-bottom">
  <div>
    <h4 className="modal-title text-primary fw-semibold d-flex align-items-center gap-2">
      <i className="ti ti-file-download text-primary" />
      Export Leads Report
    </h4>
    <small className="text-muted">
      Customize fields, filters, and export format
    </small>
  </div>

  <button
    type="button"
    className="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
</div>

            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Fields<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={fieldOptions.filter(
                      (opt) => !field.find((f) => f.value === opt.value)
                    )}
                    placeholder={
  field.length === 0
    ? "Choose fields to include in report"
    : `${field.length} fields selected`
}

                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    value={field}
                    onChange={(selectedOptions) => {
                      const selected = selectedOptions as OptionType[];
                      if (selected.some((opt) => opt.value === "ALL")) {
                        setField(fieldOptions.filter((f) => f.value !== "ALL"));
                      } else {
                        setField(selected);
                      }
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "auto",
                        height: "auto",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #ccc"
                          : base.boxShadow,
                        borderColor: state.isFocused
                          ? "#ccc"
                          : base.borderColor,
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        flexWrap: "wrap",
                        maxHeight: "100%",
                        overflowY: "auto",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        flexShrink: 0,
                      }),
                      multiValue: (base) => ({
                        ...base,
                        backgroundColor: "#eef2ff",
                        borderRadius: "8px",
                        padding: "2px 8px",
                        fontSize: "0.85rem",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                        color: "#1e40af",
                        fontWeight: 600,
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#888",
                        ":hover": {
                          backgroundColor: "#ccc",
                          color: "#000",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      
                    }}
                  />
                  
                  {field.length > 0 && (
                    <div className="mt-2">
                      <span
                        className={`badge ${
                          field.length > 10 ? "bg-danger" : "bg-secondary"
                        }`}
                      >
                        {field.length} field{field.length > 1 ? "s" : ""}{" "}
                        selected
                        {field.length > 10 && " — PDF allows max 10"}
                      </span>
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Export Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={exportTypeOptions}
                    placeholder="Select Type"
                    onChange={(e) => setExportType(e)}
                    value={exportType} // ✅ Add this line
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Filter Type</label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={filterTypeOptions}
                    onChange={(e) => {
                      setFilterType(e);
                      setFilterId(null); // ✅ Reset filterId when filterType changes
                    }}
                    value={filterType} // ✅ Add this line
                    placeholder="Select Filter Type"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    {filterType?.label || "Filter"}
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={filterIdOptions}
                    onChange={(e) => setFilterId(e)}
                    value={filterId} // ✅ Add this line
                      isDisabled={!filterType}
                     placeholder={
    filterType ? "Select filter value" : "Choose filter type first"
  }
                  />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                       Year<span className="text-danger">*</span>
                    </label>
                  <input
  type="text"
  inputMode="numeric"
  maxLength={4}
  className="form-control"
  placeholder="YYYY"
  value={year}
  onChange={(e) =>
    /^\d{0,4}$/.test(e.target.value) && setYear(e.target.value)
  }
/>

                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Select Month
                    </label>
                    <Select
                      classNamePrefix="react-select"
                      className="select"
                      options={monthOptions}
                      placeholder="Select Month"
                      onChange={(e) => setMonth(e)}
                      value={month} // ✅ Add this line
                    />
                  </div>
                </div>

                {/* <div className="mb-3">
                  <label className="form-label fw-semibold">Branch City</label>
                 <input
  type="text"
  className="form-control"
  placeholder="Enter City"
  value={branchCity}
  maxLength={50}
  onChange={(e) => {
    const value = e.target.value;

    // Allow only letters and spaces while typing
    if (/^[A-Za-z\s]*$/.test(value)) {
      setBranchCity(value);
    }
  }}
  onBlur={() => {
    // Trim spaces on blur
    setBranchCity((prev) => prev.trim().replace(/\s{2,}/g, " "));
  }}
/>

                </div> */}

                <div className="mb-3">
                  <label className="form-label fw-semibold">Lead Status</label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={leadStatusOptions}
                    onChange={(e) => setLeadStatus(e)}
                    value={leadStatus}
                    placeholder="Select Lead Status"
                  />
                </div>

             <div className="d-flex justify-content-between align-items-center mt-4">
  <small className="text-muted">
    {field.length === 0
      ? "Select at least one field to enable download"
      : "Ready to export"}
  </small>

  <div className="d-flex gap-2">
    <button
      type="button"
      className="btn btn-light"
      data-bs-dismiss="modal"
      onClick={resetForm}
    >
      Cancel
    </button>

    <button
      type="button"
      className="btn btn-primary"
      onClick={handleDownload}
      data-bs-dismiss="modal"
      disabled={field.length === 0}
    >
      <i className="ti ti-download me-1" />
      Export
    </button>
  </div>
</div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportsModal;
